<template>
  <div id="app">    
    <Navbar />
    <RoadmapPage />
    <Footer />
  </div>
</template>

<script>
import RoadmapPage from './RoadmapPage.vue'
import Navbar from '../components/Navbar.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'app',
  components: {
    Navbar,
    Footer,
    RoadmapPage
  }
}
</script>